// extracted by css-extract-rspack-plugin
export default {"diffStatesWrapper":"PullRequestHeader-module__diffStatesWrapper__l3nLn","sidePanelOpen":"PullRequestHeader-module__sidePanelOpen__hfmBh"};